var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Statistics"},[_vm._v(" Statistics ")])
}
var staticRenderFns = []

export { render, staticRenderFns }